<template>
  <div>
    <DynamicComponent edc-id="polaris-staff-management" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'StaffManagement',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
